import orderBy from 'lodash/orderBy'
import {
  getTruckList as getTruckListApi,
  updateTruck as updateTruckApi,
  addTruck as addTruckApi
} from '@/api/truck'
import dangerousGoods from '@/config/dangerous-goods'
import { toThousandFilter } from '@/tools/basic-methods'
import resetRouteMsg from '@/views/map/components/dialog/reset-route'

export const defaultVehicleSettings = {
  truckName: 'Default vehicle settings',
  heightFt: 0,
  heightIn: 0,
  widthFt: 0,
  widthIn: 0,
  lengthFt: 0,
  lengthIn: 0,
  grossWeight: 5000,
  trailers: 0,
  axles: 2,
  checkedDangerousGoods: [],
}

export const defaultVehicleSettings2 = {
  truckName: 'Default vehicle',
  heightFt: 13,
  heightIn: 6,
  widthFt: 8,
  widthIn: 6,
  lengthFt: 65,
  lengthIn: 0,
  grossWeight: '80,000',
  trailers: 1,
  axles: 5,
  checkedDangerousGoods: [],
  systemDefault: true,
  id: 'systemDefault'
}

export const defaultTruckInfo = {
  truckName: '',
  heightFt: '',
  heightIn: '',
  widthFt: '',
  widthIn: '',
  lengthFt: '',
  lengthIn: '',
  grossWeight: '',
  trailers: 1,
  axles: 5,
  checkedDangerousGoods: [],
  // readonly: false, // 保存的路线中truck不能修改
}

// 将卡车接口数据格式转换为前端格式
export function truckApiFormatToWeb(info) {
  let options = (info.options || '').toString().split(',').map(item => parseInt(item)).filter(item => !Object.is(item, NaN)).sort()
  let goods = []
  options.forEach(item => {
    let good = dangerousGoods.find(i => i.apiParam === item)
    if (good) {
      goods.push(good)
    }
  })
  goods = orderBy(goods, ['apiParam', 'age'])
  return Object.assign({}, defaultTruckInfo, {
    truckName: info.truckName || '',
    heightFt: (info.truckFtHeight || '').toString(),
    heightIn: (info.truckInHeight || '').toString(),
    widthFt: (info.truckFtWidth || '').toString(),
    widthIn: (info.truckInWidth || '').toString(),
    lengthFt: (info.truckFtLength || '').toString(),
    lengthIn: (info.truckInLength || '').toString(),
    grossWeight: info.weightLimit ? toThousandFilter(info.weightLimit) : '',
    trailers: info.trailers,
    axles: info.axles,
    id: info.id,
    checkedDangerousGoods: goods.map(item => item.value),
    isActive: false
  })
}

export function truckWebFormatToApi(info) {
  let options = info.checkedDangerousGoods.map(item => {
    let good = dangerousGoods.find(i => i.value === item)
    return good.apiParam
  })
  return {
    id: info.id || null,
    trailers: info.trailers,
    axles: info.axles,
    truckAxleCount: info.axles,
    truckFtHeight: info.heightFt,
    truckFtLength: info.lengthFt,
    truckFtWidth: info.widthFt,
    truckInHeight: info.heightIn,
    truckInLength: info.lengthIn,
    truckInWidth: info.widthIn,
    truckName: info.truckName,
    weightLimit: (info.grossWeight || '').toString().replace(/[^\d]/g, ''),
    options: options.join(',')
  }
}

export default {
  namespaced: true,
  state: {
    truckList: [], // 卡车列表
    isRequest: false, // 是否已经请求过
    requsetError: '', // 请求失败内容
    requsetLoading: false, 
  },
  mutations: {
    SET_TRUCK_LIST(state, list) {
      state.truckList = list
    },
    SET_IS_REQUEST(state, status) {
      state.isRequest = status
    },
    SET_REQUEST_ERROR(state, value) {
      state.requsetError = value
    },
    SET_REQUEST_LOADING(state, status) {
      state.requsetLoading = status
    }
  },
  actions: {
    updateTruckList({ commit }, truckList) {
      commit('SET_TRUCK_LIST', truckList)
    },
    updateActiveTruckConfirm({ rootState, dispatch }, truck) {
      let activeRoute = rootState.tripPlan.activeRoute
      if (activeRoute.routeType === 'fuelPlan') {
        resetRouteMsg.msgbox({
          visible: true,
          callback: () => { dispatch('updateActiveTruck', truck) }
        })
      } else {
        dispatch('updateActiveTruck', truck)
      }
    },
    updateActiveTruck({ commit, state, dispatch, rootState }, truck) {
      let activeTruck = {}
      let truckList = state.truckList.map(item => {
        if (item.id === truck.id) {
          activeTruck = Object.assign({}, item, { isActive: true })
          return activeTruck
        } else {
          return Object.assign({}, item, { isActive: false })
        }
      })
      commit('SET_TRUCK_LIST', truckList)
      dispatch('tripPlan/updateTruckInfo', activeTruck, { root: true })
      if (truck.id !== 'systemDefault') {
        localStorage.setItem(`activeTruck_${rootState.user.userId}`, truck.id)
      }
    },
    getTruckList({ state, commit, rootState }) {
      if (state.isRequest && !state.requsetError) return Promise.resolve(state.truckList)
      commit('SET_REQUEST_LOADING', true)
      return getTruckListApi()
      .then(res => {
        try {
          let data = res.data.data.map(item => truckApiFormatToWeb(item))
          let list = orderBy(data, ['id', 'age'])
          commit('SET_TRUCK_LIST', list)
          commit('SET_REQUEST_ERROR', '')
          return Promise.resolve(list)
        } catch(error) {
          return Promise.reject(error)
        }
      })
      .catch((error) => {
        console.log(error)
        commit('SET_REQUEST_ERROR', 'Fail to load truck info')
        let _defaultTruck = localStorage.getItem(`defaultTruck_${rootState.user.userId}`)
        let list = []
        if (_defaultTruck) {
          list = [JSON.parse(_defaultTruck)]
          commit('SET_TRUCK_LIST', list)
        } else {
          list = [defaultVehicleSettings2]
          commit('SET_TRUCK_LIST', list)
        }
        return Promise.resolve(list)
      }).finally(() => {
        commit('SET_REQUEST_LOADING', false)
        commit('SET_IS_REQUEST', true)
      })
    },
    createMyTruck({ commit, state }, truck) {
      let params = truckWebFormatToApi(truck)
      return addTruckApi(params).then(
        result => {
          try {
            let data = result.data
            let truckList = [...state.truckList]
            truckList.push(Object.assign({}, truck, { id: data.id }))
            commit('SET_TRUCK_LIST', truckList)
            return Promise.resolve()
          } catch(error) {
            return Promise.reject(error)
          }
        },
        error => {
          return Promise.reject(error)
        }
      )
    },
    updateMyTruck({ commit, state, dispatch, rootState }, truck) {
      if (truck.id === 'systemDefault') {
        localStorage.setItem(`defaultTruck_${rootState.user.userId}`, JSON.stringify(truck))
        let truckList = state.truckList.map(item => {
          if (item.id === truck.id) {
            return truck
          }
          return item
        })
        commit('SET_TRUCK_LIST', truckList)
        if (truck.isActive) {
          dispatch('tripPlan/updateTruckInfo', truck, { root: true })
        }
        return Promise.resolve(truck)
      } else {
        let params = truckWebFormatToApi(truck)
        return updateTruckApi(params).then(
          result => {
            let truckList = state.truckList.map(item => {
              if (item.id === truck.id) {
                return truck
              }
              return item
            })
            commit('SET_TRUCK_LIST', truckList)
            if (truck.isActive) {
              dispatch('tripPlan/updateTruckInfo', truck, { root: true })
            }
            return Promise.resolve(result)
          },
          error => {
            return Promise.reject(error)
          }
        )
      }
    }
  }
}